import React from 'react';
import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DrawerComponent from '../../../../../components/Drawer/Drawer';

interface UnderwritingDefinitionsSidePanelProps {
  showUnderwritingDefinitionsSidePanel: boolean;
  setShowUnderwritingDefinitionsSidePanel: React.Dispatch<React.SetStateAction<boolean>>;
  definitions: Array<{ label: string; description: string }>;
}

const UnderwritingDefinitionsSidePanel: React.FC<UnderwritingDefinitionsSidePanelProps> = ({
  showUnderwritingDefinitionsSidePanel,
  setShowUnderwritingDefinitionsSidePanel,
  definitions,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <DrawerComponent
      open={showUnderwritingDefinitionsSidePanel}
      anchor="right"
      close={() => setShowUnderwritingDefinitionsSidePanel(false)}
      height="98vh"
      zIndex={9999}
      backgroundColor="#F0F0F1"
    >
      <Box
        sx={{
          padding: '1.5rem',
          width: isMobile ? 'auto' : '600px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontSize: '1.375rem',
            fontWeight: 700,
            lineHeight: '1.875rem',
            color: '#6C6C6C',
          }}
        >
          Definitions
          <Button
            sx={{ padding: 0, minWidth: 'fit-content' }}
            onClick={() => {
              setShowUnderwritingDefinitionsSidePanel(false);
            }}
          >
            <CloseIcon sx={{ color: '#162C36' }} />
          </Button>
        </Box>
      </Box>
      <Box
        sx={{
          margin: '1rem 1.5rem',
          width: isMobile ? 'auto' : '552px',
          display: 'flex',
          flexDirection: 'column',
          gap: '0.75rem',
        }}
      >
        {definitions.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              padding: '1rem',
              borderRadius: '1rem',
              backgroundColor: '#FFFFFF',
              gap: '0.75rem',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                gap: '0.5rem',
                alignItems: 'center',
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Manrope, sans-serif',
                  fontWeight: 700,
                  fontSize: '1rem',
                  lineHeight: '1.375rem',
                }}
              >
                {item.label}
              </Typography>
            </Box>
            <Typography
              sx={{
                color: '#6C6C6C',
                fontFamily: 'Manrope, sans-serif',
                fontWeight: 500,
                fontSize: '0.875rem',
                lineHeight: '1.25rem',
              }}
            >
              {item.description}
            </Typography>
          </Box>
        ))}
      </Box>
    </DrawerComponent>
  );
};

export default UnderwritingDefinitionsSidePanel;
